<table
        (matSortChange)="onSortChange($event)"

        [dataSource]="dataSource"

        mat-table
        matSort
        style="width: 100%"
>


    <ng-container matColumnDef="ptNewsId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "thumbnail" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>
            <img *ngIf="d.thumbnail" height="50" src='{{url}}/portail/ptNews/image/{{d.ptNewsId}}' width="50">
        </td>
    </ng-container>

    <ng-container matColumnDef="title1">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>

            {{ "title1" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>
            {{ d.title1 }}
        </td>
    </ng-container>

    <ng-container matColumnDef="title2">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "title2" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>
            <a [queryParams]="{ id: d.ptNewsId }" [routerLink]="['/portail/news/details']" class="st-p">
                {{ d.title2 }}</a></td>
    </ng-container>

    <ng-container matColumnDef="titleEn">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "titleEn" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>
            <a [queryParams]="{ id: d.ptNewsId }" [routerLink]="['/portail/news/details']" class="st-p">
                {{ d.titleEn }}</a></td>
    </ng-container>


    <ng-container matColumnDef="moderNm">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "moderNm" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>{{ d.writerNm }}</td>
    </ng-container>


    <ng-container matColumnDef="modDt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "modDt_rédaction" | translate }}
        </th>
        <td *matCellDef="let d" class="text-center" mat-cell>{{ d.modDt |  customDate}}</td>
    </ng-container>


    <ng-container matColumnDef="hitCnt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "hitCnt" | translate }}
        </th>
        <td *matCellDef="let d" class="text-center" mat-cell>{{ d.hitCnt }}</td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let news" mat-cell>
            <a (click)="detailNews(news)" mat-icon-button>
                <mat-icon style="color: #00a8ff;">info</mat-icon>
            </a>

        </td>
    </ng-container>

    <tr *matHeaderRowDef="getcol()" mat-header-row></tr>
    <tr *matRowDef="let row; columns: getcol()" mat-row></tr>


</table>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
